
import React, { useState, useEffect } from 'react';
import {
  Box, Card, CardContent, Typography, Button, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow,  Chip, Alert, IconButton, 
  Tooltip, Grid, TextField, MenuItem, CircularProgress, Fade, 
  Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, List, ListItem, 
  ListItemText, ListItemIcon, Divider,Tabs, Tab
} from '@mui/material';
import {
  Warning, ShoppingCart, Refresh, TrendingDown, Inventory, AddShoppingCart, 
  Info, FilterList, CheckCircle, ArrowBack, Store, Business, Receipt, 
  ContentCopy,  Visibility, LocalShipping
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API;
const DRAWER_WIDTH = '300px';

const StockSuggestions = () => {
  const navigate = useNavigate();
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [priorityFilter, setPriorityFilter] = useState('');
  const [summary, setSummary] = useState(null);
  
  // Create PO dialog
  const [createPODialog, setCreatePODialog] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState('');
  const [distributors, setDistributors] = useState([]);


  const [tabValue, setTabValue] = useState(0); // 0 = Needs PO, 1 = PO Created
  const [poDetailsDialog, setPODetailsDialog] = useState(false);
  const [selectedPODetails, setSelectedPODetails] = useState(null);


  //  NEW: Pending Orders Dialog State
  const [pendingOrdersDialog, setPendingOrdersDialog] = useState(false);
  const [selectedPendingOrders, setSelectedPendingOrders] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    loadSuggestions();
    loadDistributors();
  }, [priorityFilter]);

  const loadSuggestions = async () => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams();
      if (priorityFilter) params.append('priority', priorityFilter);
      
      const response = await axios.get(`${API_BASE_URL}/purchase-orders/suggestions/low-stock?${params}`);
      setSuggestions(response.data.suggestions || []);
      setSummary(response.data.summary || null);
    } catch (err) {
      console.error('Error loading suggestions:', err);
      setError('Failed to load stock suggestions');
    } finally {
      setLoading(false);
    }
  };


const handleViewPODetails = (item) => {
  setSelectedPODetails({
    medicine_name: item.medicine_name,
    manufacturer: item.manufacturer,
    po_number: item.pending_po_number,
    po_date: item.pending_po_date,
    po_status: item.pending_po_status || 'CREATED',
    current_stock: item.current_stock,
    max_stock: item.max_stock,
    stock_needed: item.stock_needed
  });
  setPODetailsDialog(true);
};

const filterSuggestionsByTab = () => {
  if (tabValue === 0) {
    // Needs PO - items without pending PO
    return suggestions.filter(s => !s.has_pending_po);
  } else {
    // PO Created - items with pending PO
    return suggestions.filter(s => s.has_pending_po);
  }
};

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};


  const loadDistributors = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/distributors`);
      setDistributors(response.data.distributors || []);
    } catch (err) {
      console.error('Error loading distributors:', err);
    }
  };

  const getPriorityColor = (priority) => {
    const colors = {
      critical: 'error',
      high: 'warning',
      medium: 'info',
      low: 'success'
    };
    return colors[priority] || 'default';
  };

  const getPriorityIcon = (priority) => {
    if (priority === 'critical') return <Warning />;
    if (priority === 'high') return <TrendingDown />;
    return <Info />;
  };

  const handleSelectItem = (item) => {
    const isSelected = selectedItems.some(i => i.medicine_id === item.medicine_id);
    
    if (isSelected) {
      setSelectedItems(selectedItems.filter(i => i.medicine_id !== item.medicine_id));
    } else {
      // Auto-select the preferred distributor if available
      if (item.preferred_distributor_id && !selectedDistributor) {
        setSelectedDistributor(item.preferred_distributor_id);
      }
      
      setSelectedItems([...selectedItems, {
        medicine_id: item.medicine_id,
        medicine_name: item.medicine_name,
        manufacturer: item.manufacturer,
        generic_name: '',
        quantity_ordered: item.suggested_quantity,
        unit_price: item.last_purchase_price || 0,
        purchase_price_estimate: item.last_purchase_price || 0,
        discount_percentage: 0,
        gst_percentage: 12,
        total: (item.suggested_quantity * (item.last_purchase_price || 0))
      }]);
    }
  };
  
  //  NEW: Handle Pending Orders Click
  const handlePendingOrdersClick = (event, item) => {
    event.stopPropagation(); // Prevent row selection
    setSelectedPendingOrders({
      medicineName: item.medicine_name,
      manufacturer: item.manufacturer,
      orderCount: item.pending_orders,
      totalQuantity: item.pending_quantity,
      orderIds: item.order_ids || []
    });
    setPendingOrdersDialog(true);
  };
  const handleCopyOrderId = (orderId) => {
    navigator.clipboard.writeText(orderId);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500); // tooltip resets back
  };
  
  const handleCreatePO = () => {
    if (selectedItems.length === 0) {
      setError('Please select at least one item');
      return;
    }
    
    if (!selectedDistributor) {
      setError('Please select a distributor');
      return;
    }
    console.log(selectedDistributor)
    // Navigate with pre-filled data
    navigate('/purchase-orders/create', {
      state: {
        prefilledData: {
          distributor_id: selectedDistributor,
          items: selectedItems.map(item => ({
            medicine_id: item.medicine_id,
            medicine_name: item.medicine_name,
            manufacturer: item.manufacturer,
            generic_name: '',
            quantity_ordered: item.quantity_ordered,
            unit_price: 0,
            quantity_received: 0,
            quantity_pending: item.quantity_ordered,
            gst_percentage: 12,


          })),
          notes: 'Auto-generated from stock suggestions'
        },
        //  Tell the PO create page to redirect back here
        redirectOnSuccess: '/purchase-orders/suggestions'
      }
    });
  };

  const handleRefresh = () => {
    loadSuggestions();
  };

  if (loading && suggestions.length === 0) {
    return (
      <Box sx={{ 
        minHeight: '100vh', 
        bgcolor: '#f8f9fa',
        ml: { xs: 0, md: DRAWER_WIDTH },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={48} sx={{ mb: 2 }} />
          <Typography variant="h6" color="text.secondary">Loading stock suggestions...</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      bgcolor: '#f8f9fa',
      ml: { xs: 0, md: DRAWER_WIDTH },
      p: { xs: 2, sm: 3 }
    }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 1 }}>
          <Box>
            <IconButton onClick={() => navigate(-1)} sx={{ mr: 2 }}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a1a1a', mb: 0.5 }}>
              Stock Replenishment Suggestions
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Items that need to be reordered based on current stock levels
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            <Tooltip title="Refresh data">
              <IconButton 
                onClick={handleRefresh}
                sx={{ 
                  bgcolor: 'white',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  '&:hover': { bgcolor: '#f5f5f5' }
                }}
              >
                <Refresh />
              </IconButton>
            </Tooltip>
            {selectedItems.length > 0 && (
              <Button
                variant="contained"
                startIcon={<AddShoppingCart />}
                onClick={() => setCreatePODialog(true)}
                sx={{
                  bgcolor: '#006D77',
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                  boxShadow: '0 4px 12px rgba(37,99,235,0.25)',
                  '&:hover': {
                    bgcolor: '#004F56',
                    boxShadow: '0 6px 16px rgba(37,99,235,0.35)',
                  }
                }}
              >
                Create PO ({selectedItems.length} items)
              </Button>
            )}
          </Box>
        </Box>
      </Box>

      {/* Error Alert */}
      {error && (
        <Fade in={!!error}>
          <Alert severity="error" onClose={() => setError('')} sx={{ mb: 3 }}>
            {error}
          </Alert>
        </Fade>
      )}

      {/* Summary Cards */}
      {summary && (
        <Grid container spacing={2.5} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ 
              bgcolor: 'linear-gradient(135deg, #ef444415 0%, #ef444405 100%)',
              border: '1px solid #ef444430'
            }}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="body2" color="text.secondary">Critical</Typography>
                    <Typography variant="h4" fontWeight={700} color="error.main">
                      {summary.critical}
                    </Typography>
                  </Box>
                  <Warning sx={{ fontSize: 48, color: 'error.main', opacity: 0.3 }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ 
              bgcolor: 'linear-gradient(135deg, #f59e0b15 0%, #f59e0b05 100%)',
              border: '1px solid #f59e0b30'
            }}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="body2" color="text.secondary">High Priority</Typography>
                    <Typography variant="h4" fontWeight={700} color="warning.main">
                      {summary.high}
                    </Typography>
                  </Box>
                  <TrendingDown sx={{ fontSize: 48, color: 'warning.main', opacity: 0.3 }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ 
              bgcolor: 'linear-gradient(135deg, #3b82f615 0%, #3b82f605 100%)',
              border: '1px solid #3b82f630'
            }}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="body2" color="text.secondary">Medium</Typography>
                    <Typography variant="h4" fontWeight={700} color="info.main">
                      {summary.medium}
                    </Typography>
                  </Box>
                  <Inventory sx={{ fontSize: 48, color: 'info.main', opacity: 0.3 }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ 
              bgcolor: 'linear-gradient(135deg, #10b98115 0%, #10b98105 100%)',
              border: '1px solid #10b98130'
            }}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="body2" color="text.secondary">Low Priority</Typography>
                    <Typography variant="h4" fontWeight={700} color="success.main">
                      {summary.low}
                    </Typography>
                  </Box>
                  <CheckCircle sx={{ fontSize: 48, color: 'success.main', opacity: 0.3 }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {summary && summary.from_unfulfilled_orders > 0 && (
        <Alert 
          severity="warning" 
          icon={<ShoppingCart />}
          sx={{ mb: 3 }}
        >
          <Typography variant="body2" fontWeight={600}>
            {summary.from_unfulfilled_orders} medicines have pending customer orders waiting for stock
          </Typography>
        </Alert>
      )}

<Card sx={{ mb: 2.5, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
  <CardContent sx={{ p: 2 }}>
    <Tabs 
      value={tabValue} 
      onChange={(e, newValue) => setTabValue(newValue)}
      sx={{
        mb: 2,
        '& .MuiTab-root': {
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.95rem'
        }
      }}
    >
      <Tab 
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ShoppingCart />
            Needs Purchase Order ({suggestions.filter(s => !s.has_pending_po).length})
          </Box>
        } 
      />
      <Tab 
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LocalShipping />
            PO Created ({suggestions.filter(s => s.has_pending_po).length})
          </Box>
        } 
      />
    </Tabs>

    {/* Filter Section */}
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          sx={{ width: { xs: '100%', sm: 200, md: 300 } }}
          select
          size="medium"
          label="Filter by Priority"
          value={priorityFilter}
          onChange={(e) => setPriorityFilter(e.target.value)}
          InputProps={{
            startAdornment: <FilterList sx={{ mr: 1, color: '#9ca3af' }} />
          }}
        >
          <MenuItem value="">All Priorities</MenuItem>
          <MenuItem value="critical">Critical</MenuItem>
          <MenuItem value="high">High</MenuItem>
          <MenuItem value="medium">Medium</MenuItem>
          <MenuItem value="low">Low</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} md={8}>
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          {priorityFilter && (
            <Button
              variant="outlined"
              onClick={() => setPriorityFilter('')}
              sx={{ textTransform: 'none', fontWeight: 600 }}
            >
              Clear Filter
            </Button>
          )}
        </Box>
      </Grid>
    </Grid>
  </CardContent>
</Card>


      {/* Suggestions Table */}
      <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f9fafb' }}>
                <TableCell padding="checkbox">
                {tabValue === 0 && ( 
                  <Checkbox
                    indeterminate={selectedItems.length > 0 && selectedItems.length < suggestions.length}
                    checked={suggestions.length > 0 && selectedItems.length === suggestions.length}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedItems(suggestions.map(s => ({
                          medicine_id: s.medicine_id,
                          medicine_name: s.medicine_name,
                          manufacturer: s.manufacturer,
                          generic_name: '',
                          quantity_ordered: s.suggested_quantity,
                          unit_price: s.last_purchase_price || 0,
                          purchase_price_estimate: s.last_purchase_price || 0,
                          discount_percentage: 0,
                          gst_percentage: 12,
                          total: (s.suggested_quantity * (s.last_purchase_price || 0))
                        })));
                      } else {
                        setSelectedItems([]);
                      }
                    }}
                  />
                )}
                </TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#374151' }}>Priority</TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#374151' }}>Medicine</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Current Stock</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Max Stock</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Needed</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Stock %</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Pending Orders</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>Order Qty</TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#374151' }}>Distributors</TableCell>
                <TableCell sx={{ fontWeight: 700, color: '#374151' }}>Last Supplier</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700, color: '#374151' }}>Last Price</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: '#374151' }}>PO Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={12} align="center" sx={{ py: 4 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              // ) : suggestions.length === 0 ? (
              ) : filterSuggestionsByTab().length === 0 ? ( 
                <TableRow>
                  <TableCell colSpan={12}>
                    <Box sx={{ textAlign: 'center', py: 6 }}>
                      <CheckCircle sx={{ fontSize: 64, color: '#10b981', mb: 2 }} />
                      <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
                        All Stock Levels are Good!
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        No items are purchased at this time
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                // suggestions.map((item) => {
                  filterSuggestionsByTab().map((item) => { 
                  const isSelected = selectedItems.some(i => i.medicine_id === item.medicine_id);
                  
                  return (
                    <TableRow 
                      key={item.medicine_id}
                      hover
                      selected={isSelected}
                      sx={{ 
                        cursor: tabValue === 0 ? 'pointer' : 'default', 
                        bgcolor: item.has_pending_po ? '#F0F9FF' : 'white' 
                      }}
                      onClick={() => {
                        if (tabValue === 0 && !item.has_pending_po) { 
                          handleSelectItem(item);
                        }
                      }}
                    >

                      <TableCell padding="checkbox">
            {item.has_pending_po ? (
              <Tooltip title="PO already created">
                <IconButton 
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewPODetails(item);
                  }}
                >
                  <Visibility sx={{ color: '#006D77' }} />
                </IconButton>
              </Tooltip>
            ) : (
              <Checkbox checked={isSelected} />
            )}
          </TableCell>
                      <TableCell>
                        <Chip
                          icon={getPriorityIcon(item.priority)}
                          label={item.priority.toUpperCase()}
                          color={getPriorityColor(item.priority)}
                          size="small"
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight={600}>
                          {item.medicine_name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {item.manufacturer}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Chip 
                          label={item.current_stock}
                          size="small"
                          color={item.current_stock === 0 ? 'error' : 'default'}
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" color="text.secondary">
                          {item.max_stock}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Chip 
                          label={item.stock_needed}
                          size="small"
                          color="warning"
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                          <Typography 
                            variant="body2" 
                            fontWeight={600}
                            color={
                              item.stock_percentage <= 20 ? 'error.main' :
                              item.stock_percentage <= 40 ? 'warning.main' : 'success.main'
                            }
                          >
                            {item.stock_percentage}%
                          </Typography>
                        </Box>
                      </TableCell>

                      {/*  UPDATED: Pending Orders with Click Handler */}
                      <TableCell align="center">
                        {item.pending_orders > 0 ? (
                          <Chip 
                            label={`${item.pending_orders} orders`}
                            size="small"
                            color="error"
                            onClick={(e) => handlePendingOrdersClick(e, item)}
                            sx={{ 
                              fontWeight: 600,
                              cursor: 'pointer',
                              '&:hover': {
                                bgcolor: '#ef4444',
                                color: 'white'
                              }
                            }}
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">-</Typography>
                        )}
                      </TableCell>

                      <TableCell align="center">
                        {item.pending_quantity > 0 ? (
                          <Tooltip title="Click pending orders to view details">
                            <Chip 
                              label={item.pending_quantity}
                              size="small"
                              color="warning"
                              sx={{ fontWeight: 600 }}
                            />
                          </Tooltip>
                        ) : (
                          <Typography variant="body2" color="text.secondary">-</Typography>
                        )}
                      </TableCell>

                      {/* Distributor Display */}
                      <TableCell>
                        {item.medicine_distributors && item.medicine_distributors.length > 0 ? (
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            {item.medicine_distributors.slice(0, 2).map((dist, idx) => (
                              <Tooltip key={idx} title={`Distributor: ${dist}`}>
                                <Chip
                                  icon={<Business sx={{ fontSize: 16 }} />}
                                  label={dist}
                                  size="small"
                                  sx={{ 
                                    maxWidth: 150,
                                    fontSize: '0.75rem',
                                    bgcolor: '#e3f2fd',
                                    color: '#1976d2'
                                  }}
                                />
                              </Tooltip>
                            ))}
                            {item.medicine_distributors.length > 2 && (
                              <Tooltip title={item.medicine_distributors.slice(2).join(', ')}>
                                <Chip
                                  label={`+${item.medicine_distributors.length - 2} more`}
                                  size="small"
                                  sx={{ 
                                    fontSize: '0.7rem',
                                    height: 20,
                                    bgcolor: '#f5f5f5'
                                  }}
                                />
                              </Tooltip>
                            )}
                          </Box>
                        ) : (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Store sx={{ fontSize: 14 }} />
                            No distributors
                          </Typography>
                        )}
                      </TableCell>

                      <TableCell>
                        {item.preferred_distributor_name ? (
                          <Typography variant="body2" fontWeight={500}>
                            {item.preferred_distributor_name}
                          </Typography>
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            No history
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="body2" fontWeight={600}>
                          ₹{item.last_purchase_price?.toFixed(2) || '0.00'}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        {item.has_pending_po ? (
                          <Box>
                            <Chip 
                              label={item.pending_po_number}
                              size="small"
                              color="info"
                              icon={<LocalShipping />}
                              sx={{ mb: 0.5 }}
                            />
                            <Typography variant="caption" display="block" color="text.secondary">
                              {formatDate(item.pending_po_date)}
                            </Typography>
                            <Chip 
                              label={item.pending_po_status || 'CREATED'}
                              size="small"
                              color="warning"
                              sx={{ mt: 0.5, fontSize: '0.65rem' }}
                            />
                          </Box>
                        ) : (
                          <Typography variant="body2" color="text.secondary">-</Typography>
                        )}
                      </TableCell>

                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {suggestions.length > 0 && (
          <Box sx={{ 
            p: 2.5, 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            borderTop: '1px solid #e5e7eb'
          }}>

          <Typography variant="body2" sx={{ color: '#6b7280', fontWeight: 500 }}>
            {tabValue === 0 
              ? `${filterSuggestionsByTab().length} items need purchase orders`
              : `${filterSuggestionsByTab().length} items have pending POs`
            }
          </Typography>
            {selectedItems.length > 0 && tabValue === 0 && (
              <Button
                variant="contained"
                startIcon={<ShoppingCart />}
                onClick={() => setCreatePODialog(true)}
                sx={{
                  bgcolor: '#006D77',
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                Create PO for {selectedItems.length} items
              </Button>
            )}

          </Box>
        )}
      </Card>

      {/* NEW: Pending Orders Dialog */}
      <Dialog 
        open={pendingOrdersDialog} 
        onClose={() => setPendingOrdersDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ 
          fontWeight: 600,
          bgcolor:  '#006D77',
          borderBottom: '1px solidrgb(202, 211, 254)',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color:"white"
        }}>
          <Receipt color="black" />
          Pending Customer Orders
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          {selectedPendingOrders && (
            <>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {selectedPendingOrders.medicineName}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {selectedPendingOrders.manufacturer}
                </Typography>
                
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid item xs={6}>
                    <Card sx={{ bgcolor: '#fef2f2', border: '1px solid #fecaca' }}>
                      <CardContent sx={{ p: 2 }}>
                        <Typography variant="caption" color="text.secondary">
                          Total Orders
                        </Typography>
                        <Typography variant="h5" fontWeight={700} color="error.main">
                          {selectedPendingOrders.orderCount}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={6}>
                    <Card sx={{ bgcolor: '#fef3c7', border: '1px solid #fde68a' }}>
                      <CardContent sx={{ p: 2 }}>
                        <Typography variant="caption" color="text.secondary">
                          Total Quantity
                        </Typography>
                        <Typography variant="h5" fontWeight={700} color="warning.main">
                          {selectedPendingOrders.totalQuantity}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Typography variant="subtitle2" fontWeight={600} gutterBottom sx={{ mb: 2 }}>
                Order IDs ({selectedPendingOrders.orderIds.length})
              </Typography>

              <List sx={{ bgcolor: '#f9fafb', borderRadius: 2, p: 0 }}>
                {selectedPendingOrders.orderIds.map((orderId, index) => (
                  <React.Fragment key={orderId}>
                    <ListItem
                      sx={{
                        '&:hover': {
                          bgcolor: '#f3f4f6'
                        }
                      }}
                      secondaryAction={
                        <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip
                          title={copied ? "Copied!" : "Copy Order ID"}
                          open={copied ? true : undefined}
                          disableHoverListener={copied}
                          placement="top"
                        >
                          <IconButton 
                            size="small"
                            onClick={() => handleCopyOrderId(orderId)}
                            sx={{
                              '&:hover': {
                                bgcolor: '#e5e7eb'
                              }
                            }}
                          >
                            <ContentCopy fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        </Box>
                      }
                    >
                      <ListItemIcon>
                        <Receipt color="action" fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="body2" fontWeight={500} sx={{ fontFamily: 'monospace' }}>
                            {orderId}
                          </Typography>
                        }
                        secondary={`Order #${index + 1}`}
                      />
                    </ListItem>
                    {index < selectedPendingOrders.orderIds.length - 1 && (
                      <Divider />
                    )}
                  </React.Fragment>
                ))}
              </List>

              <Alert severity="info" sx={{ mt: 3 }}>
                <Typography variant="body2">
                  These orders are waiting for stock. Consider prioritizing this medicine in your purchase order.
                </Typography>
              </Alert>
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, borderTop: '1px solid #e5e7eb' }}>
          <Button 
            onClick={() => setPendingOrdersDialog(false)} 
            sx={{ textTransform: 'none' }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Create PO Dialog */}
      <Dialog 
        open={createPODialog} 
        onClose={() => setCreatePODialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>
          Create Purchase Order
        </DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 3 }}>
            You have selected {selectedItems.length} items for purchase order
          </Alert>
          
          <TextField
            fullWidth
            select
            label="Select Distributor"
            value={selectedDistributor}
            onChange={(e) => setSelectedDistributor(e.target.value)}
            required
            sx={{ mb: 2 }}
          >
            <MenuItem value="">Select a distributor</MenuItem>
            {distributors.map((dist) => (
              <MenuItem key={dist.distributor_id} value={dist.company_name}>
                {dist.company_name || dist.name}
              </MenuItem>
            ))}
          </TextField>

          <Typography variant="body2" color="text.secondary">
            This will take you to the purchase order creation page with the selected items pre-filled.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={() => setCreatePODialog(false)} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>
          <Button 
            variant="contained" 
            onClick={handleCreatePO}
            disabled={!selectedDistributor}
            sx={{ textTransform: 'none', fontWeight: 600 ,bgcolor:"#006D77"}}
          >
            Continue to PO Form
          </Button>
        </DialogActions>
      </Dialog>




{/* PO Details Dialog */}
<Dialog 
  open={poDetailsDialog} 
  onClose={() => setPODetailsDialog(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ 
    fontWeight: 600,
    bgcolor: '#006D77',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    gap: 1
  }}>
    <LocalShipping />
    Purchase Order Details
  </DialogTitle>
  <DialogContent sx={{ pt: 3 }}>
    {selectedPODetails && (
      <>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            {selectedPODetails.medicine_name}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {selectedPODetails.manufacturer}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <List>
          <ListItem>
            <ListItemIcon>
              <Receipt color="action" />
            </ListItemIcon>
            <ListItemText
              primary="PO Number"
              secondary={selectedPODetails.po_number}
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <Info color="action" />
            </ListItemIcon>
            <ListItemText
              primary="PO Status"
              secondary={
                <Chip 
                  label={selectedPODetails.po_status}
                  size="small"
                  color={
                    selectedPODetails.po_status === 'RECEIVED' ? 'success' :
                    selectedPODetails.po_status === 'PARTIALLY_RECEIVED' ? 'warning' :
                    'info'
                  }
                />
              }
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <Business color="action" />
            </ListItemIcon>
            <ListItemText
              primary="Created Date"
              secondary={formatDate(selectedPODetails.po_date)}
            />
          </ListItem>

          <Divider sx={{ my: 2 }} />

          <ListItem>
            <ListItemText
              primary="Current Stock"
              secondary={selectedPODetails.current_stock}
            />
          </ListItem>

          <ListItem>
            <ListItemText
              primary="Max Stock"
              secondary={selectedPODetails.max_stock}
            />
          </ListItem>

          <ListItem>
            <ListItemText
              primary="Stock Needed"
              secondary={selectedPODetails.stock_needed}
            />
          </ListItem>
        </List>

        <Alert severity="info" sx={{ mt: 2 }}>
          <Typography variant="body2">
            A purchase order has been created for this medicine. 
            Once the stock is received, pending orders will be notified automatically.
          </Typography>
        </Alert>
      </>
    )}
  </DialogContent>
  <DialogActions sx={{ p: 2.5, borderTop: '1px solid #e5e7eb' }}>
    <Button 
      onClick={() => setPODetailsDialog(false)}
      sx={{ textTransform: 'none' }}
    >
      Close
    </Button>
    <Button
      variant="contained"
      onClick={() => {
        navigate('/purchase-orders');
        setPODetailsDialog(false);
      }}
      sx={{
        bgcolor: '#006D77',
        textTransform: 'none',
        '&:hover': { bgcolor: '#005560' }
      }}
    >
      View All POs
    </Button>
  </DialogActions>
</Dialog>




    </Box>
  );
};

export default StockSuggestions;